<template>
  <va-create-layout>
    <commodity-farms-form :title="title" :item="item"></commodity-farms-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
